import client from '@/lib/axios-client'
import type {
	CreateJobGroupClusterBody,
	JobGroupCluster,
	JobGroupClusterListOutput,
	UpdateJobGroupClusterBody,
} from '@/types'

const JOB_GROUP_CLUSTERS_URL = '/job-group-clusters'

export async function getJobGroupClusters(): Promise<JobGroupClusterListOutput> {
	const response = await client.get(JOB_GROUP_CLUSTERS_URL)
	return response.data.data
}

export async function createJobGroupCluster(
	body: CreateJobGroupClusterBody,
): Promise<JobGroupCluster> {
	const response = await client.post(JOB_GROUP_CLUSTERS_URL, body)
	return response.data.data
}

export async function updateJobGroupCluster(
	id: string,
	body: UpdateJobGroupClusterBody,
): Promise<JobGroupCluster> {
	const response = await client.patch(`${JOB_GROUP_CLUSTERS_URL}/${id}`, body)
	return response.data.data
}

export async function deleteJobGroupCluster(id: string): Promise<void> {
	await client.delete(`${JOB_GROUP_CLUSTERS_URL}/${id}`)
}
